// extracted by mini-css-extract-plugin
export default {"main":"cleaningnew_main__s0ncd","stringtext":"cleaningnew_stringtext__qOiL1","box":"cleaningnew_box__TMlj+","boxnew":"cleaningnew_boxnew__I3jB-"};